import { render, staticRenderFns } from "./allBills.vue?vue&type=template&id=ec82f12c&scoped=true&"
import script from "./allBills.vue?vue&type=script&lang=js&"
export * from "./allBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec82f12c",
  null
  
)

export default component.exports